import { render, staticRenderFns } from "./CourseClassificationList.vue?vue&type=template&id=b19388b4&"
import script from "./CourseClassificationList.vue?vue&type=script&lang=js&"
export * from "./CourseClassificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports